// extracted by mini-css-extract-plugin
module.exports = {"placeholderCell":"PlaceholderCell_placeholderCell__1JPh2","notEnoughSpaceWarning":"PlaceholderCell_notEnoughSpaceWarning__32hAb"};